var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("li", { staticClass: "row py20" }, [
    _c(
      "div",
      {
        staticClass: "blend bg-cl-secondary",
        on: { click: _vm.closeWishlist }
      },
      [
        _c(
          "a",
          { attrs: { href: _vm.productLink } },
          [
            _c("product-image-cloudfront", {
              staticClass: "product__image-wrapper",
              attrs: {
                "thumbnail-path": _vm.product.thumbnail_path,
                "thumbnail-size": "40"
              }
            })
          ],
          1
        )
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "col-xs between-xs flex pl40 py15" }, [
      _c("div", { on: { click: _vm.closeWishlist } }, [
        _c(
          "a",
          {
            staticClass: "sans-serif h5 name cl-mine-shaft",
            attrs: { href: _vm.productLink }
          },
          [
            _vm._v(
              "\n        " +
                _vm._s(_vm._f("htmlDecode")(_vm.product.name)) +
                "\n      "
            )
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "h6 cl-bg-tertiary pt5 sku" }, [
          _vm._v("\n        " + _vm._s(_vm.product.sku) + "\n      ")
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "inline-flex py10 align-right" }, [
      _c("div", { staticClass: "inline-flex align-items-center" }, [
        _vm.product.price_incl_tax
          ? _c("div", [
              _c("span", { staticClass: "price-special" }, [
                _vm._v(
                  _vm._s(
                    _vm._f("price")(_vm.product.price_incl_tax, _vm.storeView)
                  )
                )
              ]),
              _vm._v(" \n      ")
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.showAddToCart
          ? _c(
              "div",
              { staticClass: "px10 cart-icon" },
              [
                _c("add-to-cart", {
                  staticClass: "wishlist-add-to-cart-icon",
                  class: [
                    {
                      "bg-cl-mine-cart":
                        _vm.product.catalog ===
                        _vm.config.rootcategories.drukowanie
                    },
                    {
                      "bg-cl-office-cart":
                        _vm.product.catalog === _vm.config.rootcategories.biuro
                    }
                  ],
                  attrs: { product: _vm.product }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", [
          _c("div", [
            _c(
              "span",
              {
                on: {
                  click: function($event) {
                    return _vm.removeProductFromWhishList(_vm.product)
                  }
                }
              },
              [_c("remove-button", { staticClass: "cl-accent" })],
              1
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }